import { InputNumber } from "antd"

export const StopInput = ({
  value,
  setValue,
  disabled = false,
} : {
  value: number | null,
  setValue: (value : number | null) => void,
  disabled?: boolean
}) => {
  return <InputNumber
    disabled
    addonBefore="$"
    style={{ display: 'block', width: '100%' }}
    placeholder="Stop Price"
    value={value}
    onChange={(value) => setValue(value)}
    min={0}
  />
}